import tw, { styled } from 'twin.macro'

export const Divider = styled.div`
    ${tw`h-[2px] my-3`}
    ${({ color }) => color && `background-color: ${color};`}
`
